export default __webpack_public_path__ + "static/media/shopping-cart.d7220e9c.png";